$(document).ready(function(){

    $(window).scroll(function(){
        var sticky = $('#shopify-section-header'),
            scroll = $(window).scrollTop();
      
        if (scroll >= 100) sticky.addClass('fixed'), sticky.addClass('fixed');
        else sticky.removeClass('fixed');
    });

    var navopener = $('.nav-opener'),
        navwrap = $('.nav-panel'),
        links = navwrap.find('a:not([data-more])'),
        navactive = 'nav-active';

    navopener.click(function () {
        $('body').toggleClass(navactive);
    });

    $('html').on('click touchstart pointerdown MSPointerDown', function (e) {
        var target = $(e.target);

        if (!target.closest(navopener).length && !target.closest(navwrap).length) {
            $('body').removeClass(navactive);
        }
    });

    $('.products__slideshow').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        prevArrow:"<button class='slick-prev slick-arrow' aria-label='Previous' type='button'></button>",
        nextArrow:"<button class='slick-next slick-arrow' aria-label='Next' type='button'></button>",
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.quotes-mobile').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        // centerMode: true,
        asNavFor: '.news__logos-mobile .news__logos-wrapper'
    });

    $('.news__logos-mobile .news__logos-wrapper').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        infinite: true,
        centerMode: true,
        asNavFor: '.quotes-mobile',
        dots: false,
        arrows: false,
        lazyLoad: 'progressive',
        focusOnSelect: true,
        centerPadding: '0px',

        // mobileFirst: true,
        responsive: [
            {
                breakpoint: 1030,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '90px',
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 770,
                settings: {
                    slidesToShow: 3,
                    centerPadding: '60px',
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '140px',
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 475,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '70px',
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('.product-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        infinite: false,
        fade: true,
        lazyLoad: 'progressive',
        asNavFor: '.product-slider-nav'
    });

    $('.product-slider-nav').slick({
        slidesToShow: 5,
        infinite: false,
        slidesToScroll: 1,
        arrows: false,
        asNavFor: '.product-slider',
        focusOnSelect: true
    });

    $('.quotes').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        dots: false,
        autoplay: true
    });

    $('.news__testimonials').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });
});

// CUSTOM SELECT
window.onload = function () {
    crear_select();
   /* crear_select_filter();*/
    crear_select_filter_tag();
}

var li = new Array();

function crear_select() {
    var div_cont_select = document.querySelectorAll("[data-mate-select='active']");
    var select_ = '';
    for (var e = 0; e < div_cont_select.length; e++) {
        div_cont_select[e].setAttribute('data-indx-select', e);
        div_cont_select[e].setAttribute('data-selec-open', 'false');
        var ul_cont = document.querySelectorAll("[data-indx-select='" + e + "'] > .cont_list_select_mate > ul");
        select_ = document.querySelectorAll("[data-indx-select='" + e + "'] >select")[0];

        var select_optiones = select_.options;
        document.querySelectorAll("[data-indx-select='" + e + "']  > .select__option ")[0].setAttribute('data-n-select', e);
        document.querySelectorAll("[data-indx-select='" + e + "']  > .icon_select_mate ")[0].setAttribute('data-n-select', e);
        for (var i = 0; i < select_optiones.length; i++) {
            li[i] = document.createElement('li');
            if (select_optiones[i].selected == true || select_.value == select_optiones[i].innerHTML) {
                li[i].className = 'active';
                document.querySelector("[data-indx-select='" + e + "']  > .select__option ").innerHTML = select_optiones[i].innerHTML;
            };
            li[i].setAttribute('data-index', i);
            li[i].setAttribute('data-selec-index', e);
            // funcion click al selecionar
            li[i].addEventListener('click', function () {
                _select_option(this.getAttribute('data-index'), this.getAttribute('data-selec-index'));
            });

            li[i].innerHTML = select_optiones[i].innerHTML;
            ul_cont[0].appendChild(li[i]);

        }; // Fin For select_optiones
    }; // fin for divs_cont_select
}

/*function crear_select_filter() {
    var div_cont_select = document.querySelectorAll("[data-mate-select='active']");
    var select_ = '';
    for (var e = 0; e < div_cont_select.length; e++) {
        div_cont_select[e].setAttribute('data-indx-select', e);
        div_cont_select[e].setAttribute('data-selec-open', 'false');
        var ul_cont = document.querySelectorAll("[data-indx-select='" + e + "'] > .cont_list_select_mate > ul");
        var currentValueP = document.querySelectorAll('.collection__sorting p.select__option');
        var sortBy = document.getElementById('sort-by');
        var currentSelectValue = sortBy.querySelector('option[value="' + sortBy.value + '"]').innerText;
        ul_cont.forEach(function (ulItem) {
            ulItem.innerHTML = Array.from(sortBy.querySelectorAll('option')).map(function (item) {
                return '<li data-value="' + item.value + '">' + item.innerText + '</li>';
            }).join('');

            ulItem.querySelectorAll('li').forEach(function (liItem) {
                liItem.addEventListener('click', function (e) {
                    var value = this.dataset.value;
                    var currentOptionText = sortBy.querySelector('option[value="' + value + '"]').innerText;
                    var selectUl = ulItem.parentNode.parentNode.querySelector('.cont_select_int');
                    var selectIcon = ulItem.parentNode.parentNode.querySelector('.icon_select_mate');
                    var currentP = ulItem.parentNode.parentNode.querySelector('.select__option');
                    sortBy.value = value;
                    sortBy.dispatchEvent(new Event('change'));
                    selectIcon.classList.remove('sorting__icon-active');
                    selectUl.classList.remove('sorting__active');
                    currentP.innerText = currentOptionText;
                });
            });
        });
        currentValueP.forEach(function (item) {
            item.innerText = currentSelectValue;
        });
    }
}*/

function crear_select_filter_tag() {
    var div_cont_select = document.querySelectorAll("[data-mate-select='active']");
    var select_ = '';
    for (var e = 0; e < div_cont_select.length; e++) {
        div_cont_select[e].setAttribute('data-indx-select', e);
        div_cont_select[e].setAttribute('data-selec-open', 'false');
        var ul_cont = document.querySelectorAll(".filter__tag .cont_list_select_mate > ul");
        var currentValueP = document.querySelectorAll('.filter__tag p.select__option');
        var sortBy = document.getElementById('sort-by-tag');
        var currentSelectValue = sortBy.querySelector('option[value="' + sortBy.value + '"]').innerText;
        ul_cont.forEach(function (ulItem) {
            ulItem.innerHTML = Array.from(sortBy.querySelectorAll('option')).map(function (item) {
                return '<li data-value="' + item.value + '">' + item.innerText + '</li>';
            }).join('');

            ulItem.querySelectorAll('li').forEach(function (liItem) {
                liItem.addEventListener('click', function (e) {
                    var value = this.dataset.value;
                    var currentOptionText = sortBy.querySelector('option[value="' + value + '"]').innerText;
                    var selectUl = ulItem.parentNode.parentNode.querySelector('.cont_select_int');
                    var selectIcon = ulItem.parentNode.parentNode.querySelector('.icon_select_mate');
                    var currentP = ulItem.parentNode.parentNode.querySelector('.select__option');
                    sortBy.value = value;
                    sortBy.dispatchEvent(new Event('change'));
                    selectIcon.classList.remove('sorting__icon-active');
                    selectUl.classList.remove('sorting__active');
                    currentP.innerText = currentOptionText;
                });
            });
        });
        currentValueP.forEach(function (item) {
            item.innerText = currentSelectValue;
        });
    }
}


// Fin Function

var cont_slc = 0;

function open_select(idx) {
    var idx1 = idx.getAttribute('data-n-select');
    var ul_cont_li = document.querySelectorAll("[data-indx-select='" + idx1 + "'] .cont_select_int > li");
    var hg = 0;
    var slect_open = document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].getAttribute('data-selec-open');
    var slect_element_open = document.querySelectorAll("[data-indx-select='" + idx1 + "'] select")[0];



        for (var i = 0; i < ul_cont_li.length; i++) {
            hg += ul_cont_li[i].offsetHeight;
        };
        if (slect_open == 'false') {
            document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].setAttribute('data-selec-open', 'true');
            document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].classList.add('active');
            document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .cont_list_select_mate > ul")[0].style.height = hg + "px";
            document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .icon_select_mate")[0].style.transform = 'rotate(180deg)';
        } else {
            document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].setAttribute('data-selec-open', 'false');
            document.querySelectorAll("[data-indx-select='" + idx1 + "']")[0].classList.remove('active');
            document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .icon_select_mate")[0].style.transform = 'rotate(0deg)';
            document.querySelectorAll("[data-indx-select='" + idx1 + "'] > .cont_list_select_mate > ul")[0].style.height = "0px";
        }

}

function open_select_filter(idx) {
    var selectUl = idx.parentNode.querySelector('.cont_select_int');
    var selectIcon = idx.parentNode.querySelector('.icon_select_mate');
    if (selectUl.classList.contains('sorting__active')) {
        // remove class
        selectIcon.classList.remove('sorting__icon-active');
        selectUl.classList.remove('sorting__active');
    } else {
        // add class
        selectIcon.classList.add('sorting__icon-active');
        selectUl.classList.add('sorting__active');
    }

}

function open_select_filter_tag(idx) {
    var selectUl = idx.parentNode.querySelector('.cont_select_int');
    var selectIcon = idx.parentNode.querySelector('.icon_select_mate');
    if (selectUl.classList.contains('sorting__active')) {
        // remove class
        selectIcon.classList.remove('sorting__icon-active');
        selectUl.classList.remove('sorting__active');
    } else {
        // add class
        selectIcon.classList.add('sorting__icon-active');
        selectUl.classList.add('sorting__active');
    }

}



// fin function open_select

function salir_select(indx) {
    var select_ = document.querySelectorAll("[data-indx-select='" + indx + "'] > select")[0];
    document.querySelectorAll("[data-indx-select='" + indx + "'] > .cont_list_select_mate > ul")[0].style.height = "0px";
    document.querySelector("[data-indx-select='" + indx + "'] > .icon_select_mate").style.transform = 'rotate(0deg)';
    document.querySelectorAll("[data-indx-select='" + indx + "']")[0].setAttribute('data-selec-open', 'false');
}

function _select_option(indx, selc) {

    var select_ = document.querySelectorAll("[data-indx-select='" + selc + "'] > select")[0];

    var li_s = document.querySelectorAll("[data-indx-select='" + selc + "'] .cont_select_int > li");
    var p_act = document.querySelectorAll("[data-indx-select='" + selc + "'] > .select__option")[0].innerHTML = li_s[indx].innerHTML;
    var select_optiones = document.querySelectorAll("[data-indx-select='" + selc + "'] > select > option");
    for (var i = 0; i < li_s.length; i++) {
        if (li_s[i].className == 'active') {
            li_s[i].className = '';
        };
        li_s[indx].className = 'active';

    };
    select_optiones[indx].selected = true;
    select_.selectedIndex = indx;
    select_.onchange();
    salir_select(selc);
}
// CUSTOM SELECT END

// ACCORDION
$(function() {
    var Accordion = function(el, multiple) {
        this.el = el || {};
        this.multiple = multiple || false;

        var links = this.el.find('.link');
        // Event
        links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
    }

    Accordion.prototype.dropdown = function(e) {
        var $el = e.data.el;
            $this = $(this),
            $next = $this.next();

        $next.slideToggle();
        $this.parent().toggleClass('open');
  

        if (!e.data.multiple) {
            $el.find('.submenu').not($next).slideUp().parent().removeClass('open');
        };
    }

    var accordion = new Accordion($('.accordion'), false);
});
// ACCORDION END

// Scroll with animation

(function($) {


    $.fn.visible = function(partial) {

        var $t            = $(this),
            $w            = $(window),
            viewTop       = $w.scrollTop(),
            viewBottom    = viewTop + $w.height(),
            _top          = $t.offset().top,
            _bottom       = _top + $t.height(),
            compareTop    = partial === true ? _bottom : _top,
            compareBottom = partial === true ? _top : _bottom;

        return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
        // console.log(compareBottom <= viewBottom)
    };

})(jQuery);

var win = $(window);

var allMods = $(".module");

allMods.each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
        el.addClass("already-visible");
    }
});

win.scroll(function(event) {

    allMods.each(function(i, el) {
        var el = $(el);
        if (el.visible(true)) {
            el.addClass("come-in");
        }
    });
});


// Already visible modules
allMods.each(function(i, el) {
    var el = $(el);
    if (el.visible(true)) {
        el.addClass("already-visible");
    }
});

win.scroll(function(event) {
    allMods.each(function(i, el) {
        var el = $(el);
        if (el.visible(true)) {
            el.addClass("come-in");
        }
    });

});

//Header Top Bar

$( ".close__bar" ).click(function() {
    $( ".announcement-bar" ).hide( "slow" );
});


/*setTimeout(function () {
        $( ".announcement-bar" ).slideUp( "slow" );
    }, 5000);*/

//After Subscribe move up 
$(document).ready(function(){
    if( window.location.href.indexOf('challenge#ContactFooter') > -1){

        $([document.documentElement, document.body]).animate({
        
        scrollTop: $('main').offset().top - 200
        
        }, 5);
        
        }
});
